import { render, staticRenderFns } from "./DailyEmailUnsubscribe.vue?vue&type=template&id=614c78d2&scoped=true&"
import script from "./DailyEmailUnsubscribe.vue?vue&type=script&lang=js&"
export * from "./DailyEmailUnsubscribe.vue?vue&type=script&lang=js&"
import style0 from "./DailyEmailUnsubscribe.vue?vue&type=style&index=0&id=614c78d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614c78d2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VContainer,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cam\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('614c78d2')) {
      api.createRecord('614c78d2', component.options)
    } else {
      api.reload('614c78d2', component.options)
    }
    module.hot.accept("./DailyEmailUnsubscribe.vue?vue&type=template&id=614c78d2&scoped=true&", function () {
      api.rerender('614c78d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DailyEmail/DailyEmailUnsubscribe.vue"
export default component.exports